import {getTodayStartTime} from 'shared/utils/dateTime';

export function isFinished({finishDate}: Budget): boolean {
  return finishDate <= getTodayStartTime();
}
